
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { ProfileFormData } from "../../types";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";
import { SPECIALTIES } from "../../constants/specialties";

interface SpecialtiesFieldProps {
  form: UseFormReturn<ProfileFormData>;
}

export const SpecialtiesField = ({ form }: SpecialtiesFieldProps) => {
  const selectedSpecialties = form.watch('specialties')?.split(',').map(spec => spec.trim()).filter(Boolean) || [];

  const handleSelectSpecialty = (specialty: string) => {
    const current = form.getValues('specialties')?.split(',').map(spec => spec.trim()).filter(Boolean) || [];
    if (!current.includes(specialty)) {
      const newSpecialties = [...current, specialty].join(', ');
      form.setValue('specialties', newSpecialties);
    }
  };

  const handleRemoveSpecialty = (specialtyToRemove: string) => {
    const newSpecialties = form.getValues('specialties')?.split(',')
      .map(spec => spec.trim())
      .filter(spec => spec !== specialtyToRemove)
      .join(', ') || '';
    form.setValue('specialties', newSpecialties);
  };

  return (
    <FormField
      control={form.control}
      name="specialties"
      render={({ field }) => (
        <FormItem className="flex flex-col gap-2">
          <FormLabel>Specialties</FormLabel>
          <FormControl>
            <Command className="rounded-lg border shadow-sm">
              <CommandInput placeholder="Search specialties..." />
              <CommandList>
                <CommandEmpty>No specialty found.</CommandEmpty>
                <CommandGroup className="max-h-64 overflow-auto">
                  {SPECIALTIES.map((specialty) => (
                    <CommandItem
                      key={specialty}
                      onSelect={() => handleSelectSpecialty(specialty)}
                      className="cursor-pointer"
                    >
                      {specialty}
                    </CommandItem>
                  ))}
                </CommandGroup>
              </CommandList>
            </Command>
          </FormControl>
          <div className="flex flex-wrap gap-2">
            {selectedSpecialties.map((specialty) => (
              <Badge
                key={specialty}
                variant="secondary"
                className="flex items-center gap-1"
              >
                {specialty}
                <X
                  className="h-3 w-3 cursor-pointer"
                  onClick={() => handleRemoveSpecialty(specialty)}
                />
              </Badge>
            ))}
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
